<div class="register-container">
  <div class="register-card">
    <!-- Header -->
    <div class="register-header">
      <div class="brand-section">
        <img src="/vat-logo.png" alt="VAT Logo" class="vat-logo">
        <h2 class="brand-title">VAT E-Service</h2>
      </div>
      <h1 class="register-title">ลงทะเบียนผู้ใช้งานใหม่</h1>
      <p class="register-subtitle">กรุณากรอกข้อมูลเพื่อสร้างบัญชีผู้ใช้งาน</p>
    </div>

    <!-- Progress Bar -->
    <div class="progress-section">
      <div class="progress">
        <div class="progress-bar" role="progressbar" [style.width.%]="(currentStep / totalSteps) * 100"></div>
      </div>
      <div class="progress-steps">
        <div *ngFor="let step of [1, 2]" class="step-item">
          <div class="step-circle" [class.completed]="step < currentStep" [class.current]="step === currentStep"
            [class.clickable]="step <= currentStep" (click)="goToStep(step)">
            <i *ngIf="step < currentStep" class="bi bi-check-lg"></i>
            <span *ngIf="step >= currentStep">{{ step }}</span>
          </div>
          <div class="step-label">
            <span *ngIf="step === 1">ข้อมูลส่วนตัว</span>
            <span *ngIf="step === 2">ข้อมูลวิชาชีพ</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Form -->
    <form [formGroup]="createUserForm" (ngSubmit)="onSubmit()" class="register-form">

      <!-- Step 1: Personal Information -->
      <div class="step-content" *ngIf="currentStep === 1">
        <div class="form-section">
          <h3 class="section-title">
            <i class="bi bi-person-circle"></i>
            ข้อมูลส่วนตัว
          </h3>

          <div class="row mb-4">
            <div class="col-12 text-center">
              <div class="profile-upload-container position-relative d-inline-block">
                <!-- If the user has uploaded an image, show it. Otherwise show default or placeholder -->
                <ng-container *ngIf="createUserForm.get('profilePicture')?.value || !isUploadingProfile">
                  <ng-container *ngIf="createUserForm.get('profilePicture')?.value as profileUrl">
                    <img [src]="profileUrl" alt="Profile Picture" class="rounded-circle profile-preview shadow-sm"
                      style="width: 150px; height: 150px; object-fit: cover; border: 3px solid #dee2e6; background-color: #f8f9fa;">
                  </ng-container>
                  <ng-container *ngIf="!createUserForm.get('profilePicture')?.value">
                    <div
                      class="rounded-circle profile-preview shadow-sm d-flex align-items-center justify-content-center bg-light text-secondary"
                      style="width: 150px; height: 150px; border: 3px dashed #dee2e6;">
                      <div class="text-center">
                        <i class="bi bi-person-fill" style="font-size: 4rem; opacity: 0.5;"></i>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>

                <div *ngIf="isUploadingProfile"
                  class="rounded-circle profile-preview shadow-sm d-flex align-items-center justify-content-center bg-light"
                  style="width: 150px; height: 150px; border: 3px solid #dee2e6;">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">กำลังอัพโหลด...</span>
                  </div>
                </div>

                <label for="profileImageInput"
                  class="upload-btn position-absolute bottom-0 end-0 bg-primary text-white rounded-circle p-2 shadow"
                  style="cursor: pointer; transform: translate(-10%, -10%); z-index: 10;">
                  <i class="bi bi-camera-fill px-1"></i>
                </label>
                <input type="file" id="profileImageInput" class="d-none"
                  accept="image/jpeg,image/jpg,image/png,image/gif" (change)="onProfilePictureSelect($event)"
                  [disabled]="isUploadingProfile">
              </div>
              <div class="mt-2 text-muted small">อัพโหลดรูปโปรไฟล์ (JPG, PNG, GIF ขนาดไม่เกิน 5MB)</div>
              <div *ngIf="createUserForm.get('profilePicture')?.value" class="mt-1">
                <span class="badge bg-success"><i class="bi bi-check-circle-fill me-1"></i>อัพโหลดรูปภาพสำเร็จ</span>
              </div>
              <div *ngIf="isUploadingProfile" class="mt-1 text-primary small">
                กำลังอัพโหลดรูปภาพ...
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2 mb-3">
              <label class="form-label required">คำนำหน้า</label>
              <select class="form-select" formControlName="prefix" [class.is-invalid]="hasError('prefix')">
                <option value="">เลือก</option>
                <option value="นาย">นาย</option>
                <option value="นาง">นาง</option>
                <option value="นางสาว">นางสาว</option>
              </select>
              <div class="invalid-feedback" *ngIf="hasError('prefix')">
                {{ getErrorMessage('prefix') }}
              </div>
            </div>

            <div class="col-md-5 mb-3">
              <label class="form-label required">ชื่อ</label>
              <input type="text" class="form-control" formControlName="firstName"
                [class.is-invalid]="hasError('firstName')" placeholder="กรอกชื่อ">
              <div class="invalid-feedback" *ngIf="hasError('firstName')">
                {{ getErrorMessage('firstName') }}
              </div>
            </div>

            <div class="col-md-5 mb-3">
              <label class="form-label required">นามสกุล</label>
              <input type="text" class="form-control" formControlName="lastName"
                [class.is-invalid]="hasError('lastName')" placeholder="กรอกนามสกุล">
              <div class="invalid-feedback" *ngIf="hasError('lastName')">
                {{ getErrorMessage('lastName') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label required">อีเมล</label>
              <input type="email" class="form-control" formControlName="email" [class.is-invalid]="hasError('email')"
                placeholder="example@email.com">
              <div class="invalid-feedback" *ngIf="hasError('email')">
                {{ getErrorMessage('email') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label required">เบอร์โทรศัพท์</label>
              <input type="tel" class="form-control" formControlName="phone" [class.is-invalid]="hasError('phone')"
                placeholder="กรุณากรอกเบอร์โทรศัพท์" maxlength="10">
              <div class="invalid-feedback" *ngIf="hasError('phone')">
                {{ getErrorMessage('phone') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label required">เลขบัตรประชาชน</label>
              <input type="text" class="form-control" formControlName="cid" [class.is-invalid]="hasError('cid')"
                placeholder="1234567890123" maxlength="13" readonly>
              <small class="form-text text-muted" *ngIf="userCid">
                <i class="bi bi-info-circle"></i> ข้อมูลจากบัญชีผู้ใช้ของคุณ (ไม่สามารถแก้ไขได้)
              </small>
              <div class="invalid-feedback" *ngIf="hasError('cid')">
                {{ getErrorMessage('cid') }}
              </div>
            </div>

            <div class="col-md-3 mb-3">
              <label class="form-label required">เพศ</label>
              <select class="form-select" formControlName="gender" [class.is-invalid]="hasError('gender')">
                <option value="">เลือกเพศ</option>
                <option value="Male">ชาย</option>
                <option value="Female">หญิง</option>
              </select>
              <div class="invalid-feedback" *ngIf="hasError('gender')">
                {{ getErrorMessage('gender') }}
              </div>
            </div>

            <div class="col-md-3 mb-3">
              <label class="form-label required">วันเกิด (พ.ศ.)</label>
              <input type="text" class="form-control" formControlName="birthDate"
                [class.is-invalid]="hasError('birthDate')"
                placeholder="dd/mm/yyyy"
                maxlength="10"
                (input)="onBirthDateInput($event)"
                (blur)="validateBirthDate()">
              <div class="invalid-feedback" *ngIf="hasError('birthDate')">
                {{ getErrorMessage('birthDate') }}
              </div>
              <small class="text-muted d-block mt-1">
                <i class="bi bi-info-circle"></i> รูปแบบ: วว/ดด/ปปปป (พ.ศ.) เช่น 15/05/2543
              </small>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">เลือกที่ทำงานปัจจุบัน</label>
              <div class="position-relative">
                <div class="input-group">
                  <input 
                    type="text" 
                    class="form-control" 
                    [(ngModel)]="companySearchText"
                    [ngModelOptions]="{standalone: true}"
                    (input)="onCompanySearchChange()"
                    (focus)="onCompanyInputFocus()"
                    (blur)="showCompanyDropdown = false"
                    placeholder="-- เลือกองค์กร --"
                    autocomplete="off"
                  />
                  <button 
                    class="btn btn-outline-secondary" 
                    type="button"
                    *ngIf="selectedCompany"
                    (mousedown)="clearCompanySelection()"
                    title="ล้างการเลือก"
                  >
                    <i class="bi bi-x-lg"></i>
                  </button>
                  <span class="input-group-text">
                    <i class="bi bi-chevron-down"></i>
                  </span>
                </div>
                
                <!-- Dropdown List -->
                <div 
                  class="company-dropdown-list" 
                  *ngIf="showCompanyDropdown && !isLoadingCompanies"
                  (mousedown)="$event.preventDefault()"
                >
                  <div class="dropdown-item-wrapper" *ngIf="filteredCompanyList.length > 0">
                    <div 
                      class="dropdown-item company-item" 
                      *ngFor="let company of filteredCompanyList"
                      (mousedown)="selectCompany(company)"
                    >
                      <i class="bi bi-building me-2 text-primary"></i>
                      {{ company.organizationName }}
                    </div>
                  </div>
                  <div class="dropdown-item text-muted text-center" *ngIf="filteredCompanyList.length === 0">
                    <i class="bi bi-search me-2"></i>
                    ไม่พบองค์กรที่ค้นหา
                  </div>
                </div>
              </div>
            </div>

            <!-- Company Details Display - Improved Design -->
            <div class="col-md-12 mb-3" *ngIf="selectedCompany">
              <div class="card shadow-sm border-0">
                <div class="card-header bg-primary text-white">
                  <h6 class="mb-0">
                    <i class="bi bi-building-fill me-2"></i>
                    รายละเอียดองค์กร
                  </h6>
                </div>
                <div class="card-body">
                  <div class="row g-3">
                    <!-- Organization Name - Full Width -->
                    <div class="col-12">
                      <div class="d-flex align-items-center mb-2">
                        <i class="bi bi-building text-primary me-2"></i>
                        <strong>ชื่อองค์กร:</strong>
                      </div>
                      <div class="ms-4">{{ selectedCompany.organizationName }}</div>
                    </div>

                    <div class="col-md-6 mb-2">
                      <div class="d-flex align-items-start">
                        <i class="bi bi-tag-fill text-primary me-2 mt-1"></i>
                        <div>
                          <small class="text-muted d-block">ประเภท</small>
                          <span>{{ selectedCompany.organizationType }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 mb-2">
                      <div class="d-flex align-items-start">
                        <i class="bi bi-credit-card-fill text-primary me-2 mt-1"></i>
                        <div>
                          <small class="text-muted d-block">เลขประจำตัวผู้เสียภาษี</small>
                          <span>{{ selectedCompany.taxId }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 mb-2">
                      <div class="d-flex align-items-start">
                        <i class="bi bi-telephone-fill text-primary me-2 mt-1"></i>
                        <div>
                          <small class="text-muted d-block">โทรศัพท์</small>
                          <span>{{ selectedCompany.officePhone }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 mb-2">
                      <div class="d-flex align-items-start">
                        <i class="bi bi-envelope-fill text-primary me-2 mt-1"></i>
                        <div>
                          <small class="text-muted d-block">อีเมล</small>
                          <span>{{ selectedCompany.email }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 mb-2">
                      <div class="d-flex align-items-start">
                        <i class="bi bi-globe text-primary me-2 mt-1"></i>
                        <div>
                          <small class="text-muted d-block">เว็บไซต์</small>
                          <span>{{ selectedCompany.website || '-' }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 mb-2">
                      <div class="d-flex align-items-start">
                        <i class="bi bi-chat-dots-fill text-success me-2 mt-1"></i>
                        <div>
                          <small class="text-muted d-block">Line ID</small>
                          <span>{{ selectedCompany.lineId || '-' }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 mb-0">
                      <div class="d-flex align-items-start">
                        <i class="bi bi-geo-alt-fill text-danger me-2 mt-1"></i>
                        <div>
                          <small class="text-muted d-block">ที่อยู่</small>
                          <span>{{ selectedCompany.headOfficeAddress }}, {{ selectedCompany.taxSubdistrict }}, {{
                            selectedCompany.taxDistrict }}, {{ selectedCompany.taxProvince }} {{
                            selectedCompany.postalCode }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Address Section -->
        <div class="form-section">
          <h3 class="section-title">
            <i class="bi bi-house-door"></i>
            ที่อยู่
          </h3>

          <!-- Registered Address -->
          <div class="address-card registered">
            <h4 class="address-title">ที่อยู่ตามทะเบียนบ้าน</h4>
            <div class="row">
              <div class="col-md-12 mb-3">
                <label class="form-label required">ที่อยู่</label>
                <input type="text" class="form-control" formControlName="registeredAddress"
                  [class.is-invalid]="hasError('registeredAddress')" placeholder="บ้านเลขที่ ซอย ถนน">
                <div class="invalid-feedback" *ngIf="hasError('registeredAddress')">
                  {{ getErrorMessage('registeredAddress') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">จังหวัด</label>
                <select class="form-select" formControlName="registeredProvince"
                  [class.is-invalid]="hasError('registeredProvince')"
                  (change)="onRegisteredProvinceChange($event)">
                  <option value="">-- เลือกจังหวัด --</option>
                  <option *ngFor="let province of provinceList" [value]="province.name_th">
                    {{ province.name_th }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="hasError('registeredProvince')">
                  {{ getErrorMessage('registeredProvince') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">อำเภอ/เขต</label>
                <select class="form-select" formControlName="registeredDistrict"
                  [class.is-invalid]="hasError('registeredDistrict')"
                  [disabled]="registeredDistrictList.length === 0"
                  (change)="onRegisteredDistrictChange($event)">
                  <option value="">-- เลือกอำเภอ/เขต --</option>
                  <option *ngFor="let district of registeredDistrictList" [value]="district.name_th">
                    {{ district.name_th }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="hasError('registeredDistrict')">
                  {{ getErrorMessage('registeredDistrict') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">ตำบล/แขวง</label>
                <select class="form-select" formControlName="registeredSubdistrict"
                  [class.is-invalid]="hasError('registeredSubdistrict')"
                  [disabled]="registeredSubdistrictList.length === 0"
                  (change)="onRegisteredSubdistrictChange($event)">
                  <option value="">-- เลือกตำบล/แขวง --</option>
                  <option *ngFor="let subdistrict of registeredSubdistrictList" [value]="subdistrict.name_th">
                    {{ subdistrict.name_th }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="hasError('registeredSubdistrict')">
                  {{ getErrorMessage('registeredSubdistrict') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">รหัสไปรษณีย์</label>
                <select class="form-select" formControlName="registeredPostalCode"
                  [class.is-invalid]="hasError('registeredPostalCode')"
                  [disabled]="registeredZipCodeList.length === 0"
                  (change)="onRegisteredPostalCodeChange($event)">
                  <option value="">-- เลือกรหัสไปรษณีย์ --</option>
                  <option *ngFor="let zipCode of registeredZipCodeList" [value]="zipCode.code">
                    {{ zipCode.code }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="hasError('registeredPostalCode')">
                  {{ getErrorMessage('registeredPostalCode') }}
                </div>
              </div>
            </div>
          </div>

          <!-- Current Address -->
          <div class="address-card current">
            <div class="address-header">
              <h4 class="address-title">ที่อยู่ปัจจุบัน</h4>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="sameAsRegistered" formControlName="sameAsRegistered"
                  (change)="onSameAsRegisteredChange($event)">
                <label class="form-check-label" for="sameAsRegistered">
                  เหมือนที่อยู่ตามทะเบียนบ้าน
                </label>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 mb-3">
                <label class="form-label required">ที่อยู่</label>
                <input type="text" class="form-control" formControlName="currentAddress"
                  [class.is-invalid]="hasError('currentAddress')" placeholder="บ้านเลขที่ ซอย ถนน">
                <div class="invalid-feedback" *ngIf="hasError('currentAddress')">
                  {{ getErrorMessage('currentAddress') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">จังหวัด</label>
                <select class="form-select" formControlName="currentProvince"
                  [class.is-invalid]="hasError('currentProvince')"
                  (change)="onCurrentProvinceChange($event)">
                  <option value="">-- เลือกจังหวัด --</option>
                  <option *ngFor="let province of provinceList" [value]="province.name_th">
                    {{ province.name_th }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="hasError('currentProvince')">
                  {{ getErrorMessage('currentProvince') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">อำเภอ/เขต</label>
                <select class="form-select" formControlName="currentDistrict"
                  [class.is-invalid]="hasError('currentDistrict')"
                  [disabled]="currentDistrictList.length === 0"
                  (change)="onCurrentDistrictChange($event)">
                  <option value="">-- เลือกอำเภอ/เขต --</option>
                  <option *ngFor="let district of currentDistrictList" [value]="district.name_th">
                    {{ district.name_th }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="hasError('currentDistrict')">
                  {{ getErrorMessage('currentDistrict') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">ตำบล/แขวง</label>
                <select class="form-select" formControlName="currentSubdistrict"
                  [class.is-invalid]="hasError('currentSubdistrict')"
                  [disabled]="currentSubdistrictList.length === 0"
                  (change)="onCurrentSubdistrictChange($event)">
                  <option value="">-- เลือกตำบล/แขวง --</option>
                  <option *ngFor="let subdistrict of currentSubdistrictList" [value]="subdistrict.name_th">
                    {{ subdistrict.name_th }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="hasError('currentSubdistrict')">
                  {{ getErrorMessage('currentSubdistrict') }}
                </div>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label required">รหัสไปรษณีย์</label>
                <select class="form-select" formControlName="currentPostalCode"
                  [class.is-invalid]="hasError('currentPostalCode')"
                  [disabled]="currentZipCodeList.length === 0">
                  <option value="">-- เลือกรหัสไปรษณีย์ --</option>
                  <option *ngFor="let zipCode of currentZipCodeList" [value]="zipCode.code">
                    {{ zipCode.code }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="hasError('currentPostalCode')">
                  {{ getErrorMessage('currentPostalCode') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 2: Professional Information -->
      <div class="step-content" *ngIf="currentStep === 2">
        <div class="form-section">
          <h3 class="section-title">
            <i class="bi bi-briefcase"></i>
            ข้อมูลวิชาชีพ
          </h3>

          <!-- VAT Member Zone -->
          <div class="professional-card vat-member">
            <h4 class="professional-title">
              <i class="bi bi-award"></i>
              สมาชิก VAT
            </h4>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label required">ประเภทสมาชิก VAT</label>
                <select class="form-select" formControlName="vatMemberType"
                  [class.is-invalid]="hasError('vatMemberType')">
                  <option value="ยังไม่มีบัตรสมาชิก">ยังไม่มีบัตรสมาชิก</option>
                  <option value="วิสามัญ">วิสามัญ</option>
                  <option value="สามัญ">สามัญ</option>
                  <option value="ตลอดชีพ">ตลอดชีพ</option>
                </select>
                <div class="invalid-feedback" *ngIf="hasError('vatMemberType')">
                  {{ getErrorMessage('vatMemberType') }}
                </div>
              </div>

              <div class="col-md-6 mb-3" *ngIf="createUserForm.get('vatMemberType')?.value !== 'ยังไม่มีบัตรสมาชิก'">
                <label class="form-label"
                  [class.required]="!createUserForm.get('isLifetimeMember')?.value">วันหมดอายุสมาชิก VAT (พ.ศ.)</label>
                <input type="text" class="form-control" formControlName="vatMemberExpiry"
                  [class.is-invalid]="hasError('vatMemberExpiry')"
                  [disabled]="createUserForm.get('isLifetimeMember')?.value"
                  placeholder="dd/mm/yyyy"
                  maxlength="10"
                  (input)="onVatMemberExpiryInput($event)"
                  (blur)="validateVatMemberExpiry()">
                <div class="invalid-feedback" *ngIf="hasError('vatMemberExpiry')">
                  {{ getErrorMessage('vatMemberExpiry') }}
                </div>
                <div class="form-check mt-2">
                  <input class="form-check-input" type="checkbox" formControlName="isLifetimeMember"
                    id="isLifetimeMember" (change)="onLifetimeMemberChange($event)">
                  <label class="form-check-label" for="isLifetimeMember">
                    ตลอดชีพ
                  </label>
                </div>
              </div>

              <div class="col-md-6 mb-3" *ngIf="createUserForm.get('vatMemberType')?.value !== 'ยังไม่มีบัตรสมาชิก'">
                <label class="form-label">หมายเลขสมาชิก VAT (VAT ID)</label>
                <input type="text" class="form-control" formControlName="vatId" placeholder="กรอกหมายเลขสมาชิก VAT">
              </div>
            </div>
          </div>

          <!-- Valuer Zone -->
          <div class="professional-card valuer">
            <h4 class="professional-title">
              <i class="bi bi-star"></i>
              ผู้ประเมินหลัก
            </h4>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label required">ผู้ประเมินหลักประเภท (Valuer Rank)</label>
                <select class="form-select" formControlName="valuerRank" [class.is-invalid]="hasError('valuerRank')">
                  <option value="ไม่มี">ไม่มี</option>
                  <option value="วิสามัญ">วิสามัญ</option>
                  <option value="สามัญ">สามัญ</option>
                  <option value="วุฒิ">วุฒิ</option>
                </select>
                <div class="invalid-feedback" *ngIf="hasError('valuerRank')">
                  {{ getErrorMessage('valuerRank') }}
                </div>
              </div>

              <div class="col-md-6 mb-3" *ngIf="createUserForm.get('valuerRank')?.value !== 'ไม่มี'">
                <label class="form-label required">วันหมดอายุชั้นผู้ประเมิน (พ.ศ.)</label>
                <input type="text" class="form-control" formControlName="valuerRankExpiry"
                  [class.is-invalid]="hasError('valuerRankExpiry')"
                  placeholder="dd/mm/yyyy"
                  maxlength="10"
                  (input)="onValuerRankExpiryInput($event)"
                  (blur)="validateValuerRankExpiry()">
                <div class="invalid-feedback" *ngIf="hasError('valuerRankExpiry')">
                  {{ getErrorMessage('valuerRankExpiry') }}
                </div>
              </div>

              <div class="col-md-6 mb-3" *ngIf="createUserForm.get('valuerRank')?.value !== 'ไม่มี'">
                <label class="form-label">หมายเลขผู้ประเมินหลัก</label>
                <input type="text" class="form-control" formControlName="valuerId"
                  placeholder="กรอกหมายเลขผู้ประเมินหลัก">
              </div>
            </div>
          </div>

          <!-- Valuation Experience -->
          <div class="dynamic-section">
            <div class="section-header">
              <h4>ประสบการณ์การประเมินมูลค่า</h4>
              <button type="button" class="btn btn-sm btn-primary" (click)="addValuationExperience()">
                <i class="bi bi-plus-lg"></i> เพิ่ม
              </button>
            </div>

            <div *ngFor="let exp of valuationExperience.controls; let i = index" class="dynamic-item">
              <div class="row">
                <div class="col-md-4 mb-3">
                  <label class="form-label">องค์กร</label>
                  <input type="text" class="form-control" [formControl]="$any(exp).get('organization')"
                    placeholder="ชื่อองค์กร">
                </div>

                <div class="col-md-4 mb-3">
                  <label class="form-label">ตำแหน่ง</label>
                  <input type="text" class="form-control" [formControl]="$any(exp).get('position')"
                    placeholder="ตำแหน่งงาน">
                </div>

                <div class="col-md-3 mb-3">
                  <label class="form-label">จำนวนปี</label>
                  <input type="number" class="form-control" [formControl]="$any(exp).get('years')" placeholder="ปี"
                    min="0">
                </div>

                <div class="col-md-1 mb-3 d-flex align-items-end">
                  <button type="button" class="btn btn-danger btn-sm w-100" (click)="removeValuationExperience(i)"
                    [disabled]="valuationExperience.length === 1">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Education Background -->
          <div class="dynamic-section">
            <div class="section-header">
              <h4>ประวัติการศึกษา</h4>
              <button type="button" class="btn btn-sm btn-primary" (click)="addEducationBackground()">
                <i class="bi bi-plus-lg"></i> เพิ่ม
              </button>
            </div>

            <div *ngFor="let edu of educationBackground.controls; let i = index" class="dynamic-item">
              <div class="row">
                <div class="col-md-5 mb-3">
                  <label class="form-label">สถาบันการศึกษา</label>
                  <input type="text" class="form-control" [formControl]="$any(edu).get('institution')"
                    placeholder="ชื่อสถาบัน">
                </div>

                <div class="col-md-4 mb-3">
                  <label class="form-label">วุฒิการศึกษา/สาขา</label>
                  <input type="text" class="form-control" [formControl]="$any(edu).get('degree')"
                    placeholder="ปริญญา/สาขา">
                </div>

                <div class="col-md-2 mb-3">
                  <label class="form-label">ปีที่จบ (พ.ศ.)</label>
                  <input type="number" class="form-control" [formControl]="$any(edu).get('year')" placeholder="2566"
                    min="2500" max="2600">
                </div>

                <div class="col-md-1 mb-3 d-flex align-items-end">
                  <button type="button" class="btn btn-danger btn-sm w-100" (click)="removeEducationBackground(i)"
                    [disabled]="educationBackground.length === 1">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- VAT Courses -->
          <div class="dynamic-section">
            <div class="section-header">
              <h4>ผ่านการอบรม/สัมมนา ที่จัดโดย VAT และ กลต.ช่วง พ.ศ 2564-2568</h4>
              <button type="button" class="btn btn-sm btn-primary" (click)="addVatCourse()">
                <i class="bi bi-plus-lg"></i> เพิ่ม
              </button>
            </div>

            <div *ngIf="isLoadingCourses" class="text-center py-3">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">กำลังโหลดคอร์ส...</span>
              </div>
              <p class="mt-2">กำลังโหลดรายการคอร์ส...</p>
            </div>

            <div *ngFor="let course of vatCourses.controls; let i = index" class="dynamic-item">
              <div class="row">
                <div class="col-md-5 mb-3">
                  <label class="form-label">เลือกคอร์สอบรม/สัมมนา</label>
                  <select class="form-select" [formControl]="$any(course).get('courseId')"
                    (change)="onCourseSelect(i, $event)" [disabled]="isLoadingCourses">
                    <option value="">-- เลือกคอร์ส --</option>
                    <option *ngFor="let c of courseList" [value]="c.id">
                      {{ c.title }}
                    </option>
                  </select>
                </div>

                <div class="col-md-3 mb-3">
                  <label class="form-label">จำนวน CPD (ชั่วโมง)</label>
                  <input type="number" class="form-control" [formControl]="$any(course).get('cpdHours')" placeholder="0"
                    readonly min="0">
                </div>

                <div class="col-md-3 mb-3">
                  <label class="form-label">วันที่จบหลักสูตร</label>
                  <input type="date" class="form-control" [formControl]="$any(course).get('completionDate')"
                    placeholder="เลือกวันที่" readonly>
                </div>

                <div class="col-md-12 mb-3">
                  <label class="form-label">อัพโหลดหลักฐาน (รูปภาพ หรือ PDF)</label>
                  <input type="file" class="form-control" accept="image/*,application/pdf"
                    (change)="onVatCourseFileSelectAndUpload(i, $event)" [id]="'vatCourseFile_' + i"
                    [disabled]="isSubmitting">
                  <small class="form-text text-muted">
                    <i class="bi bi-info-circle"></i> รองรับไฟล์: JPG, PNG, GIF, PDF (ขนาดไม่เกิน 5MB) -
                    อัพโหลดอัตโนมัติเมื่อเลือกไฟล์
                  </small>
                  <div *ngIf="$any(course).get('uploadStatus')?.value === 'uploading'" class="mt-2">
                    <span class="badge bg-info">
                      <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                      กำลังอัพโหลด...
                    </span>
                  </div>
                  <div *ngIf="$any(course).get('uploadStatus')?.value === 'success'" class="mt-2">
                    <span class="badge bg-success">
                      <i class="bi bi-check-circle-fill me-1"></i> อัพโหลดสำเร็จ
                    </span>
                  </div>
                  <div *ngIf="$any(course).get('uploadStatus')?.value === 'error'" class="mt-2">
                    <span class="badge bg-danger">
                      <i class="bi bi-x-circle-fill me-1"></i> อัพโหลดล้มเหลว
                    </span>
                  </div>
                  <div *ngIf="$any(course).get('imageThumbnail')?.value" class="mt-2">
                    <button type="button" class="btn btn-primary btn-sm" (click)="viewVatCourseImage(i)">
                      <i class="bi bi-file-earmark-text me-1"></i> ดูไฟล์หลักฐาน
                    </button>
                  </div>
                </div>

                <div class="col-md-12 mb-3 d-flex justify-content-end gap-2">
                  <button type="button" class="btn btn-danger btn-sm" (click)="removeVatCourse(i)"
                    [disabled]="vatCourses.length === 1">
                    ลบข้อมูล
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Special Courses by Other Organizations -->
          <div class="dynamic-section">
            <div class="section-header">
              <h4>หัวข้ออบรม/สัมมนา ที่จัดโดยหน่วยงานอื่น</h4>
              <button type="button" class="btn btn-sm btn-primary" (click)="addSpecialCourse()">
                <i class="bi bi-plus-lg"></i> เพิ่ม
              </button>
            </div>

            <div *ngFor="let course of specialCourses.controls; let i = index" class="dynamic-item">
              <div class="row g-3">
                <div class="col-lg-4 col-md-6 mb-3">
                  <label class="form-label fw-semibold">
                    <i class="bi bi-book me-1 text-primary"></i>หัวข้อหลักสูตร
                  </label>
                  <input type="text" class="form-control form-control-lg"
                    [formControl]="$any(course).get('courseTopic')" placeholder="กรอกชื่อหลักสูตร">
                </div>

                <div class="col-lg-4 col-md-6 mb-3">
                  <label class="form-label fw-semibold">
                    <i class="bi bi-building me-1 text-success"></i>หน่วยงาน/สถาบัน
                  </label>
                  <input type="text" class="form-control form-control-lg"
                    [formControl]="$any(course).get('organization')" placeholder="กรอกชื่อหน่วยงาน">
                </div>

                <div class="col-lg-2 col-md-4 mb-3">
                  <label class="form-label fw-semibold">
                    <i class="bi bi-clock me-1 text-info"></i>CPD (ชั่วโมง)
                  </label>
                  <input type="number" class="form-control form-control-lg text-center"
                    [formControl]="$any(course).get('cpdHours')" placeholder="0" min="0" step="0.5">
                </div>

                <div class="col-lg-2 col-md-4 mb-3">
                  <label class="form-label fw-semibold">
                    <i class="bi bi-trash me-1 text-danger"></i>ลบ
                  </label>
                  <button type="button" class="btn btn-outline-danger btn-lg w-100" (click)="removeSpecialCourse(i)"
                    [disabled]="specialCourses.length === 1" title="ลบรายการนี้">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </div>

              <!-- Second Row for Date and Status -->
              <div class="row g-3 mt-1">
                <div class="col-lg-6 col-md-8 mb-3">
                  <label class="form-label fw-semibold">
                    <i class="bi bi-calendar-event me-1 text-warning"></i>วันที่เข้ารับการอบรม
                  </label>
                  <input type="text" class="form-control form-control-lg"
                    [formControl]="$any(course).get('trainingDate')" 
                    placeholder="dd/mm/yyyy"
                    title="กรอกวันที่เข้ารับการอบรม">
                  <small class="text-muted">
                    <i class="bi bi-info-circle me-1"></i>รูปแบบ: วว/ดด/ปปปป (พ.ศ.) เช่น 15/05/2543
                  </small>
                </div>

              </div>

              <!-- Divider between items -->
              <hr class="my-4 border-2 border-light" *ngIf="i < specialCourses.length - 1">
            </div>
          </div>

        </div>

        <!-- Consent Section -->
        <div class="form-section mt-4">
          <div class="card border-primary">
            <div class="card-header bg-primary text-white">
              <h5 class="mb-0">
                <i class="bi bi-shield-check"></i>
                การยินยอมและข้อตกลง
              </h5>
            </div>
            <div class="card-body">
              <!-- Consent Details -->
              <div class="consent-details mb-3">
                <h6 class="fw-bold mb-3">ข้อกำหนดและเงื่อนไขการใช้บริการ</h6>

                <div class="consent-content p-3 bg-light rounded" style="max-height: 300px; overflow-y: auto;">
                  <p class="mb-2"><strong>1. การรับรองความถูกต้องของข้อมูล</strong></p>
                  <p class="mb-3">ข้าพเจ้ารับรองว่าข้อมูลทั้งหมดที่ได้กรอกในแบบฟอร์มนี้เป็นความจริงและถูกต้องครบถ้วน
                    หากมีการตรวจสอบพบว่าข้อมูลไม่ถูกต้อง ข้าพเจ้ายินยอมให้สมาคมผู้ประเมินค่าทรัพย์สินแห่งประเทศไทย (VAT)
                    ดำเนินการตามระเบียบที่กำหนดไว้</p>

                  <p class="mb-2"><strong>2. การเก็บรักษาและใช้ข้อมูลส่วนบุคคล</strong></p>
                  <p class="mb-3">ข้าพเจ้ายินยอมให้สมาคมผู้ประเมินค่าทรัพย์สินแห่งประเทศไทย (VAT) เก็บรักษา ประมวลผล
                    และใช้ข้อมูลส่วนบุคคลของข้าพเจ้าเพื่อวัตถุประสงค์ดังต่อไปนี้:</p>
                  <ul class="mb-3">
                    <li>การพิจารณาคุณสมบัติและการอนุมัติการเป็นสมาชิก</li>
                    <li>การจัดทำและออกบัตรสมาชิก บัตรผู้ประเมินหลัก</li>
                    <li>การติดต่อสื่อสารเกี่ยวกับกิจกรรม การอบรม และข่าวสารของสมาคม</li>
                    <li>การจัดทำสถิติและรายงานเพื่อการบริหารจัดการ</li>
                    <li>การปฏิบัติตามกฎหมายและข้อบังคับที่เกี่ยวข้อง</li>
                  </ul>

                  <p class="mb-2"><strong>3. การเปิดเผยข้อมูล</strong></p>
                  <p class="mb-3">ข้าพเจ้ายินยอมให้สมาคมฯ เปิดเผยข้อมูลของข้าพเจ้าต่อหน่วยงานที่เกี่ยวข้อง เช่น
                    สำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์ (ก.ล.ต.) และหน่วยงานราชการที่มีอำนาจตามกฎหมาย</p>

                  <p class="mb-2"><strong>4. การรักษาความลับ</strong></p>
                  <p class="mb-3">สมาคมฯ
                    จะเก็บรักษาข้อมูลส่วนบุคคลของท่านไว้เป็นความลับและจะไม่เปิดเผยต่อบุคคลภายนอกโดยไม่ได้รับความยินยอมจากท่าน
                    เว้นแต่กรณีที่กฎหมายกำหนดให้ต้องเปิดเผย</p>

                  <p class="mb-2"><strong>5. สิทธิของเจ้าของข้อมูล</strong></p>
                  <p class="mb-3">ท่านมีสิทธิในการเข้าถึง แก้ไข ลบ
                    หรือขอให้ระงับการใช้ข้อมูลส่วนบุคคลของท่านได้ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562</p>

                  <p class="mb-2"><strong>6. การปฏิบัติตามจรรยาบรรณ</strong></p>
                  <p class="mb-3">ข้าพเจ้ารับทราบและยอมรับที่จะปฏิบัติตามจรรยาบรรณของผู้ประเมินค่าทรัพย์สิน ระเบียบ
                    และข้อบังคับของสมาคมผู้ประเมินค่าทรัพย์สินแห่งประเทศไทย</p>

                  <p class="mb-2"><strong>7. การชำระค่าธรรมเนียม</strong></p>
                  <p class="mb-3">ข้าพเจ้ายินยอมชำระค่าธรรมเนียมการสมัครสมาชิก ค่าบำรุงสมาชิก และค่าธรรมเนียมอื่นๆ
                    ตามที่สมาคมฯ กำหนด</p>

                  <p class="mb-2"><strong>8. การแจ้งเปลี่ยนแปลงข้อมูล</strong></p>
                  <p class="mb-0">ข้าพเจ้าจะแจ้งให้สมาคมฯ ทราบหากมีการเปลี่ยนแปลงข้อมูลส่วนบุคคล ข้อมูลการติดต่อ
                    หรือข้อมูลอื่นๆ ที่เกี่ยวข้อง เพื่อให้สมาคมฯ สามารถติดต่อได้อย่างถูกต้องและรวดเร็ว</p>
                </div>
              </div>

              <!-- Consent Checkbox -->
              <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="consentAccepted" id="consentCheckbox"
                  [class.is-invalid]="hasError('consentAccepted')">
                <label class="form-check-label fw-bold" for="consentCheckbox">
                  <span class="text-danger">*</span>
                  ข้าพเจ้าได้อ่านและเข้าใจข้อกำหนดและเงื่อนไขการใช้บริการข้างต้นแล้ว
                  และยินยอมปฏิบัติตามข้อกำหนดดังกล่าวทุกประการ
                </label>
                <div class="invalid-feedback d-block" *ngIf="hasError('consentAccepted')">
                  กรุณายอมรับข้อกำหนดและเงื่อนไขก่อนลงทะเบียน
                </div>
              </div>

              <!-- Warning Alert -->
              <div class="alert alert-warning mt-3 mb-0" role="alert">
                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                <strong>หมายเหตุ:</strong> การลงทะเบียนจะไม่สมบูรณ์จนกว่าท่านจะยอมรับข้อกำหนดและเงื่อนไขการใช้บริการ
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Navigation Buttons -->
      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="cancel()">
          <i class="bi bi-x-lg"></i> ยกเลิก
        </button>

        <div class="action-buttons">
          <button type="button" class="btn btn-outline-primary" *ngIf="currentStep > 1" (click)="prevStep()">
            <i class="bi bi-arrow-left"></i> ย้อนกลับ
          </button>

          <button type="button" class="btn btn-primary" *ngIf="currentStep < totalSteps" (click)="nextStep()">
            ถัดไป <i class="bi bi-arrow-right"></i>
          </button>

          <button type="submit" class="btn btn-success" *ngIf="currentStep === totalSteps"
            [disabled]="isSubmitting || !createUserForm.get('consentAccepted')?.value">
            <span *ngIf="!isSubmitting">
              <i class="bi bi-check-lg"></i> ลงทะเบียน
            </span>
            <span *ngIf="isSubmitting">
              <span class="spinner-border spinner-border-sm me-2"></span>
              กำลังลงทะเบียน...
            </span>
          </button>
        </div>
      </div>
    </form>

    <!-- Footer -->
    <div class="register-footer">
      <p>มีบัญชีอยู่แล้ว? <a (click)="goToLogin()" class="login-link" style="cursor: pointer;">เข้าสู่ระบบ</a></p>
      <p class="copyright">&copy; 2026 VAT Management System. All rights reserved.</p>
    </div>
  </div>
</div>